// extracted by mini-css-extract-plugin
module.exports = {"pickupEventPreview":"AddPickupDialogTooltip_pickupEventPreview__3GMvv","carrierName":"AddPickupDialogTooltip_carrierName__TuiV2"};